import { gql } from 'graphql-request';

const GenerateProcessQuery = gql`
  mutation GenerateProcess($processJob: ProcessJobDto!, $queue: String!, $responsible: String!) {
    GenerateProcess(processJob: $processJob, queue: $queue, responsible: $responsible)
  }
`;
export default GenerateProcessQuery;
